import constants from '../config/constants';

/** @type {import('@nuxt/types').Plugin} */
const axiosExtend = ({ $axios, app }) => {
    $axios.onRequest(config => {
        if (!config.headers) {
            config.headers = {};
        }

        const csrf = app.$cookies.get(constants.CSRF_COOKIE_NAME);
        if (csrf) {
            config.headers['x-csrf-token'] = csrf;
        }
    });
    $axios.onError(error => {
        // TW-3962: Interceptor to check if there is a Network Error
        // and in that case set the response data to an empty object
        // to prevent trying to read undefined data and triggering errors.
        if (error.message === 'Network Error' && error.response && typeof error.response.data === 'undefined') {
            error.response.data = {};
        }
    });
};

export default axiosExtend;
